import React, { ChangeEvent, useEffect } from 'react';

import { ReturnComponentType } from 'common';
import { useTypedDispatch } from 'hooks';
import { SearchInput } from 'ui-kit';

type CommonSearchType = {
  actionCreator: Function;
  value?: string;
  className?: string;
  placeholder?: string;
};
export const CommonSearch = ({
  value,
  actionCreator,
  className,
  placeholder,
}: CommonSearchType): ReturnComponentType => {
  const dispatch = useTypedDispatch();
  const onChangeSearch = ({
    currentTarget: { value },
  }: ChangeEvent<HTMLInputElement>) => {
    dispatch(actionCreator(value));
  };

  useEffect(() => {
    // on dismount, reset the search value
    return () => {
      dispatch(actionCreator(''));
    };
  }, []);

  return (
    <SearchInput
      className={className}
      placeholder={placeholder}
      value={value}
      onChange={e => onChangeSearch(e)}
    />
  );
};
